import { injectStoresData, injectStoresReducer } from '@monofe/appstate';
import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import type { AnyAction } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';
import { initialState, STORE_NAME } from './constants';
import type { A2HSStorage } from './interface';
import { slice } from './slice';

export function isDataStore(object: unknown): object is A2HSStorage {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }
    const record = object as Partial<A2HSStorage>;

    return (
        !isNullOrUndefined(record.heading) &&
        !isNullOrUndefined(record.subheading) &&
        !isNullOrUndefined(record.appIconUrl)
    );
}

export function dataFromGlobalStore(globalStore: unknown): A2HSStorage | undefined {
    if (globalStore === undefined || globalStore === null || typeof globalStore !== 'object') {
        return undefined;
    }

    const data = (globalStore as Record<string, unknown>)[STORE_NAME];

    return isDataStore(data) ? data : undefined;
}

export function getStore(): A2HSStorage {
    const globalStore = injectStoresData().store.getState() as unknown;
    return dataFromGlobalStore(globalStore) ?? initialState;
}

export function useStore(): A2HSStorage {
    const data = useSelector(globalStore => dataFromGlobalStore(globalStore));
    return data ?? initialState;
}

export function setupStore(container: IContainer = injectOrBuildContainer()) {
    const reducerRegister = injectStoresReducer(container);
    reducerRegister.addSlice(slice);
}

export function dispatchAction(action: AnyAction) {
    const store = injectStoresData();
    store.dispatch(action);
}
